require('../less/timerNstopWatch/master.less');

import $ks from './lib/ks';
import Responsive from './lib/responsive';

const common = {
    // bgContainers: $ks.getByClass('bgContainer'),
    mains: $ks.getByClass('main'),
    tabs: $ks.getByClass('tabBtn'),

    turnOnClass: (elements, condition, className) => {
        elements.forEach((element) => {
            if (element.classList.contains(condition))
                element.classList.add(className);
            else
                element.classList.remove(className);
        });
    },

    // bg 바꿔주기
    bgSwitcher: (type) => {
        switch (type) {
            case 'timer' :
                document.body.style.backgroundImage = 'url(./src/img/timer/timer_bg_pattern.png)';
                document.body.style.backgroundColor = '';
                document.body.backgroundSizeInfo = 50;
                break;
            case 'stopWatch' :
                document.body.style.backgroundImage = 'url(./src/img/stopWatch/stopWatch_bg_pattern.png)';
                document.body.style.backgroundColor = '';
                document.body.backgroundSizeInfo = 50;
                break;
            case 'timerAni' :
                document.body.style.backgroundImage = 'url(./src/img/timer/aniPage/timerAni_bg_pattern.png)';
                document.body.style.backgroundColor = '#3398cc';
                document.body.backgroundSizeInfo = 58;
                break;
        }
    },

    // body 배경 size 설정
    bodyBgSizer: (type = 'default') => {
        let zoomValue = common.zoomValue;

        if (type === 'timerAni') // 타이머 애니 화면일 경우만 다름
            document.body.style.backgroundSize = zoomValue > 1 ? '58px' : `${58 * zoomValue}px`;
        else
            document.body.style.backgroundSize = zoomValue > 1 ? '50px' : `${50 * zoomValue}px`;
    },

    // body sizer
    bodySizer: () => {
        document.body.style.width = `${window.innerWidth}px`;
        document.body.style.height = `${window.innerHeight}px`;
    },

    // window 가로 : 세로 비율 가져오기
    get windowRatio() { return window.innerWidth / window.innerHeight; },

    // zoom value 가져오기
    get zoomValue() {
        let zoomValue;
        if (this.windowRatio >= 1280 / 800) { // 세로 고정
            zoomValue = window.innerHeight / 800;
        } else { // 가로 고정
            zoomValue = window.innerWidth / 1280;
        }
        return zoomValue;
    }
};

// body size와 background 설정
common.bodySizer();
common.bodyBgSizer();
window.addEventListener('resize', function() {
    common.bodySizer();
    common.bodyBgSizer();
});

let responsive = new Responsive($ks.getById('wrap'));
responsive.start();

const timerParams = {
    startAni: (type, time) => {
        timerAni.start(type, time);
    }
};

const timerAniParams = {
    go2timer: () => {
        timer.reset();
    },
    go2stopWatch: () => {
        stopWatch.reset();
    }
};

import Timer from './timer/timer.js';
import TimerAni from './timer/timerAni.js';
import StopWatch from './stopWatch/stopWatch.js';

const timer = new Timer(common, timerParams);
const timerAni = new TimerAni(common, timerAniParams);
const stopWatch = new StopWatch(common);

timer.init();
timerAni.init();
stopWatch.init();

common.tabs.forEach((tab) => {
    $ks.addHoverEvents(tab);
    $ks.addDownEvents(tab);
    tab.addEventListener('click', (e) => {
        if ($ks.hasClass(e.target, 'timer')) {
            timer.reset();
        } else {
            stopWatch.reset();
        }
    }, false);
});
